import { Check, HighlightOff, ReportProblem } from "@mui/icons-material";
import { Button, Dialog, DialogContent, IconButton } from "@mui/material";
import React, { useState } from "react";
import { decryptString, encryptHMACString } from "../app.utils";
import moment from 'moment';
import { useNavigate } from "react-router-dom";

interface Plan {
  id: string;
  name: string;
  price: number;
  activationPeriod: number;
  type: string;
  features: string[];
}

const SubscriptionCard = ({ plan }: { plan: Plan }) => {

  const navigate = useNavigate();

  const salt = `${process.env.REACT_APP_API_NEST_URL}`;
  const merchatId = `${process.env.REACT_APP_JAZZCASH_MERCHANT_ID}`;
  const merchantPass = `${process.env.REACT_APP_JAZZCASH_MERCHANT_PASS}`;
  const jazzCashReturnURL = `${process.env.REACT_APP_JAZZCASH_RETURN_URL}`;

  const JazzCashLogo = require("../assets/jazzcash-logo.png");
  const MasterCardLogo = require("../assets/mastercard-logo.svg").default;
  const VizaCardLogo = require("../assets/visa-logo.svg").default;

  const userId = decryptString(localStorage.getItem('userId') || '');
  const role = decryptString(localStorage.getItem('role'));
  const userPlan = decryptString(localStorage.getItem('userPlanId'));

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const calcHash = () => {
    var unhashedString = salt;

    fields.forEach((item) => {
      if (jazzCashData[item]) {
        unhashedString += "&" + jazzCashData[item];
      }
    });
    return encryptHMACString(unhashedString);
  }

  const getDateTime = (minutesToAdd = 0) => {
    const date = moment();
    if (minutesToAdd) {
      date.add(minutesToAdd, 'minutes');
    }
    return date.format('YYYYMMDDHHmmss');
  };

  // TODO: fetch this from API
  const jazzCashData: any = {
    pp_Version: "1.1",
    pp_TxnType: "MPAY",
    pp_Language: "EN",
    pp_MerchantID: merchatId,
    pp_SubMerchantID: "",
    pp_Password: merchantPass,
    pp_BankID: "TBANK",
    pp_ProductID: plan.id,
    pp_TxnRefNo: "T" + getDateTime(),
    pp_Amount: plan.price + '00',
    pp_TxnCurrency: "PKR",
    pp_TxnDateTime: getDateTime(),
    pp_BillReference: "T" + getDateTime(),
    pp_Description: "Description of transaction",
    pp_TxnExpiryDateTime: getDateTime(30),
    pp_ReturnURL: jazzCashReturnURL,
    ppmpf_1: userId,
    ppmpf_2: plan.id,
    ppmpf_3: "3",
    ppmpf_4: "4",
    ppmpf_5: "5"
  }

  const fields = [
    "pp_Amount",
    "pp_BankID",
    "pp_BillReference",
    "pp_Description",
    "pp_Language",
    "pp_MerchantID",
    "pp_Password",
    "pp_ProductID",
    "pp_ReturnURL",
    "pp_TxnCurrency",
    "pp_TxnDateTime",
    "pp_TxnExpiryDateTime",
    "pp_TxnRefNo",
    "pp_TxnType",
    "pp_Version",
    "ppmpf_1",
    "ppmpf_2",
    "ppmpf_3",
    "ppmpf_4",
    "ppmpf_5",
  ]

  return (
    <>
      <div className={'flex flex-col w-[23rem] mb-3'}>
        <div className={`flex flex-col gap-2 items-center bg-white min-h-[29rem] ${plan.id === userPlan ? 'border-[3px] border-[#D91E25]' : 'border border-slate-200'} rounded-xl pt-3 shadow-lg`}>
          <div className="flex flex-col gap-2 px-4 py-3 items-center w-full">
            {plan.name === 'Free Users' ? (
              <p className="text-[1.5rem] font-bold py-[2.3rem]">
                Free Tier
              </p>
            ) : (
              <>
                <p className="text-[1.5rem] font-bold">
                  {plan.name}
                </p>
                <p className="text-4xl font-normal text-center tracking-tight">
                  <span className="text-lg font-light">Rs.</span> {plan.price}
                </p>
                <span className="text-sm font-light">for {plan.activationPeriod} days.</span>
              </>
            )}
            {(role === 'free' || plan.id === userPlan) && (<Button color='primary' variant='outlined' onClick={() => setIsDialogOpen(true)} className='w-full' disabled={plan.id === userPlan}> {plan.id === userPlan ? ('Subscribed') : ('Upgrade')}</Button>)}
            {(userId === '') && (<Button color='primary' variant='outlined' onClick={() => navigate('/auth')} className='w-full'>Get Started</Button>)}
            {/* <a className='text-sm cursor-pointer hover:underline' onClick={() => { window.open('/terms-of-use', '_blank', 'noopener,noreferrer') }}>* Terms and conditions apply.</a> */}
          </div>
          <div className="w-full h-full rounded-b-xl bg-[#f6f8fa] px-6 py-4">
            <p className="mb-3 font-semibold">Includes</p>
            <ul >
              {plan.features.map((feature: any) => (
                <li key={feature} className="flex flex-row justify-start mb-3">
                  <Check fontSize="small" className="mr-2 text-green-600" />
                  <p className="font-normal text-sm">{feature}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Dialog fullWidth open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <div className="flex flex-row bg-gradient-to-b from-[#41090b] to-[#150303] justify-end p-2 gap-2 items-center border-b-[0.1px] border-b-black border-opacity-50">
          <IconButton
            onClick={() => { setIsDialogOpen(false) }}
            size="small"
            className='action'
            sx={{ color: '#D91E25' }}>
            <HighlightOff fontSize='small' />
          </IconButton>
        </div>
        <DialogContent>
          <div className="flex flex-col gap-6">
            <p className="text-xl font-bold my-2 text-center">Your Ultimate Access to EastLaw is Just One Step Away</p>
            <div className="flex flex-row gap-3 justify-center items-center w-full">
              <img src={JazzCashLogo} className="w-[6rem] pr-[1rem] border-r-[1px] border-r-gray-300" />
              <img src={VizaCardLogo} className="w-[3rem]" />
              <img src={MasterCardLogo} className="w-[3rem]" />
            </div>
            <p>After clicking on the <b className="text-primary">Pay via JazzCash</b>, you will be redirected to JazzCash payment gateway where you can pay the amount using your <b className="text-primary">Visa | Master</b> cards.</p>
            {userId && (<form className="w-full" name="jsform" method="post" action='https://sandbox.jazzcash.com.pk/CustomerPortal/transactionmanagement/merchantform/'>
              <input className="hidden" type="hidden" name="pp_Version" value={jazzCashData.pp_Version} />
              <input className="hidden" type="hidden" name="pp_TxnType" value={jazzCashData.pp_TxnType} />
              <input className="hidden" type="hidden" name="pp_Language" value={jazzCashData.pp_Language} />
              <input className="hidden" type="hidden" name="pp_MerchantID" value={jazzCashData.pp_MerchantID} />
              <input className="hidden" type="hidden" name="pp_SubMerchantID" value={jazzCashData.pp_SubMerchantID} />
              <input className="hidden" type="hidden" name="pp_Password" value={jazzCashData.pp_Password} />
              <input className="hidden" type="hidden" name="pp_BankID" value={jazzCashData.pp_BankID} />
              <input className="hidden" type="hidden" name="pp_ProductID" value={jazzCashData.pp_ProductID} />
              <input className="hidden" type="hidden" name="pp_TxnRefNo" value={jazzCashData.pp_TxnRefNo} />
              <input className="hidden" type="hidden" name="pp_Amount" value={jazzCashData.pp_Amount} />
              <input className="hidden" type="hidden" name="pp_TxnCurrency" value={jazzCashData.pp_TxnCurrency} />
              <input className="hidden" type="hidden" name="pp_TxnDateTime" value={jazzCashData.pp_TxnDateTime} />
              <input className="hidden" type="hidden" name="pp_BillReference" value={jazzCashData.pp_BillReference} />
              <input className="hidden" type="hidden" name="pp_Description" value={jazzCashData.pp_Description} />
              <input className="hidden" type="hidden" name="pp_TxnExpiryDateTime" value={jazzCashData.pp_TxnExpiryDateTime} />
              <input className="hidden" type="hidden" name="pp_ReturnURL" value={jazzCashData.pp_ReturnURL} />
              <input className="hidden" type="hidden" name="pp_SecureHash" value={calcHash()} />
              <input className="hidden" type="hidden" name="ppmpf_1" value={jazzCashData.ppmpf_1} />
              <input className="hidden" type="hidden" name="ppmpf_2" value={jazzCashData.ppmpf_2} />
              <input className="hidden" type="hidden" name="ppmpf_3" value="3" />
              <input className="hidden" type="hidden" name="ppmpf_4" value="4" />
              <input className="hidden" type="hidden" name="ppmpf_5" value="5" />
              {(role === 'free' || plan.id === userPlan) && (<Button color='primary' type="submit" variant='outlined' className='w-full' disabled={plan.id === userPlan}>Pay via JazzCash</Button>)}
            </form>)}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SubscriptionCard;
